import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import '../styles/InputQuantity.css';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

/*
 * A component for displaying a custom input for quantities.
 * @component
 */
const InputQuantity = ({disabled = false, max, quantity, setQuantity}) => {
    /** References */
    const quantityInput = useRef(null);

    /** Event Handlers */
    const onChangeQuantity = (e) => setQuantity(parseInt(e.target.value));
    const onClickDecrement = () => setQuantity(quantity < 2 ? 1 : quantity - 1);
    const onClickIncrement = () => {
        let nextQuantity;
        if (typeof max !== 'number') {
            nextQuantity = quantity + 1;
        } else if (quantity >= max) {
            nextQuantity = quantity;
        } else {
            nextQuantity = quantity + 1;
        }
        setQuantity(nextQuantity);
    };


    return (
        <div
            className={'input-quantity--container'}
        >
            <input
                className={'input-quantity--input-box'}
                disabled={disabled}
                name={'quantity'}
                ref={quantityInput}
                type={'number'}
                value={quantity}
                onChange={onChangeQuantity}
                {...Math.min(1, max) > -1 && ({ min: Math.min(1, max) })}
                {...max > 0 && ({ max })}
            />
            <div
                className={'input-quantity--arrows-container'}
            >
                <button
                    className={'input-quantity--arrow-button'}
                    disabled={disabled || (typeof max === 'number' && quantity >= max)}
                    onClick={onClickIncrement}
                    type={'button'}
                >
                    <FaChevronUp
                        size={'10px'}
                    />
                </button>
                <button
                    className={'input-quantity--arrow-button'}
                    disabled={disabled || quantity < 2}
                    onClick={onClickDecrement}
                    type={'button'}
                >
                    <FaChevronDown
                        size={'10px'}
                    />
                </button>
            </div>
        </div>
    );
};

/** Prop Types */
InputQuantity.propTypes = {
    /** Indicate whether the input and buttons should be disabled. */
    disabled: PropTypes.bool,
    /** The maximum quantity that can be set in the input. */
    max: PropTypes.number,
    /** The `quantity` state from the parent component. */
    quantity: PropTypes.number,
    /** The setter for the `quantity` state in the parent component. */
    setQuantity: PropTypes.func,
};

export default InputQuantity;
